/* ============================================================
   FIRE DESTROYER - SHOPIFY THEME JS
   ============================================================ */

(function() {
  'use strict';

  // ---- MOBILE MENU ----
  const mobileToggle = document.getElementById('mobile-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function() {
      const isHidden = mobileNav.hidden;
      mobileNav.hidden = !isHidden;
      mobileToggle.setAttribute('aria-expanded', String(isHidden));
    });
  }

  // ---- HEADER SCROLL SHADOW ----
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 20) {
        header.style.background = 'rgba(10,10,10,0.98)';
      } else {
        header.style.background = 'rgba(10,10,10,0.92)';
      }
    }, { passive: true });
  }

  // ---- DROPDOWN MENU ----
  const dropdownToggles = document.querySelectorAll('.header-nav__link--dropdown');
  dropdownToggles.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
    });
    // Close on outside click
    document.addEventListener('click', function(e) {
      if (!btn.closest('.header-nav__dropdown').contains(e.target)) {
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });

  // ---- SMOOTH SCROLL FOR ANCHOR LINKS ----
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (mobileNav) mobileNav.hidden = true;
      }
    });
  });

  // ---- SPEED MATTERS TABS ----
  const speedTabs = document.querySelectorAll('.speed-tab');
  const tabFd = document.getElementById('tab-fd');
  const tabTraditional = document.getElementById('tab-traditional');
  const fdMarker = document.getElementById('fd-marker');
  const fdBar = document.querySelector('.fire-bar.fd-activates');

  speedTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      speedTabs.forEach(function(t) { t.classList.remove('active'); });
      tab.classList.add('active');
      const which = tab.dataset.tab;
      if (which === 'fd') {
        if (tabFd) tabFd.hidden = false;
        if (tabTraditional) tabTraditional.hidden = true;
        if (fdMarker) fdMarker.style.display = 'block';
        if (fdBar) fdBar.querySelector('.fire-bar__fill').style.height = 'var(--h)';
        // Show FD fires at ignition bar only
        document.querySelectorAll('.fire-bar').forEach(function(bar, i) {
          const fill = bar.querySelector('.fire-bar__fill');
          if (i >= 3) { // Fire ignition and beyond hidden for FD
            fill.style.opacity = '0.2';
          } else {
            fill.style.opacity = '1';
          }
        });
      } else {
        if (tabFd) tabFd.hidden = true;
        if (tabTraditional) tabTraditional.hidden = false;
        if (fdMarker) fdMarker.style.display = 'none';
        document.querySelectorAll('.fire-bar').forEach(function(bar) {
          bar.querySelector('.fire-bar__fill').style.opacity = '1';
        });
      }
    });
  });

  // ---- SIZE SELECTOR (product page) ----
  const sizeOptions = document.querySelectorAll('.size-option');
  const sizeWeight = document.getElementById('size-weight');
  if (sizeOptions.length && sizeWeight) {
    sizeOptions.forEach(function(opt) {
      opt.addEventListener('click', function() {
        sizeOptions.forEach(function(o) { o.classList.remove('active'); });
        opt.classList.add('active');
        const weight = opt.dataset.weight;
        sizeWeight.innerHTML = weight + '<sub>g</sub>';
      });
    });
  }

  // ---- PRODUCT IMAGE GALLERY (thumbnails) ----
  const thumbs = document.querySelectorAll('.product-gallery__thumbs .thumb');
  const mainImg = document.getElementById('main-product-img');
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg && thumb.dataset.full) {
        mainImg.src = thumb.dataset.full;
      }
    });
  });

  // ---- VARIANT SELECTOR (product page) ----
  const variantBtns = document.querySelectorAll('.variant-btn');
  const variantIdInput = document.getElementById('variant-id');
  const priceEl = document.getElementById('product-price');
  variantBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      variantBtns.forEach(function(b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
      if (variantIdInput) variantIdInput.value = btn.dataset.variantId;
      if (priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
    });
  });

  // ---- ADD TO CART AJAX ----
  const productForm = document.getElementById('product-form');
  const cartNotification = document.getElementById('cart-notification');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      const submitBtn = productForm.querySelector('[name="add"]');
      if (!submitBtn) return;
      e.preventDefault();
      const formData = new FormData(productForm);
      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        submitBtn.textContent = 'ADDED!';
        submitBtn.style.background = '#4ade80';
        submitBtn.style.color = '#000';
      openCartDrawer();
              setTimeout(function() {
          submitBtn.textContent = 'ADD TO CART';
                    submitBtn.disabled = false;
          submitBtn.style.background = '';
          submitBtn.style.color = '';
        }, 2500);
      })
      .catch(function() {
        submitBtn.textContent = 'Error - Try again';
        submitBtn.disabled = false;
        setTimeout(function() { submitBtn.textContent = 'ADD TO CART'; }, 2000);
      });

          });
            }

              // ---- CART DRAWER ----
                const cartDrawer = document.getElementById('cart-drawer');
                const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
                const cartDrawerClose = document.getElementById('cart-drawer-close');
                const cartDrawerItems = document.getElementById('cart-drawer-items');
                const cartDrawerSubtotal = document.getElementById('cart-drawer-subtotal');
                const cartDrawerFooter = document.getElementById('cart-drawer-footer');
                const headerCartToggle = document.getElementById('header-cart-toggle');
                const cartCountEls = document.querySelectorAll('.cart-count');

                function formatMoney(cents) {
                return '$' + (cents / 100).toFixed(2);
                }

                function updateCartCount(count) {
                cartCountEls.forEach(function(el) {
                el.textContent = count;
                el.hidden = count === 0;
                });
                }

                  function renderCartDrawer(cart) {
                  updateCartCount(cart.item_count);
                  if (!cartDrawerItems) return;
                  if (cart.item_count === 0) {
                  cartDrawerItems.innerHTML = '<div class="cart-drawer__empty">Your cart is empty</div>';
                  if (cartDrawerFooter) cartDrawerFooter.hidden = true;
                  return;
                  }
                  if (cartDrawerFooter) cartDrawerFooter.hidden = false;
                  var rows = cart.items.map(function(item) {
                  var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_150x$1$2') : '';
                  return '<div class="cart-drawer__item" data-key="' + item.key + '">' +
                  '<img class="cart-drawer__item-image" src="' + img + '" alt="' + item.product_title + '">' +
                  '<div class="cart-drawer__item-details">' +
                  '<span class="cart-drawer__item-title">' + item.product_title + '</span>' +
                  '<span class="cart-drawer__item-price">' + formatMoney(item.final_price) + '</span>' +
                  '<div class="cart-drawer__item-footer">' +
                  '<div class="cart-drawer__qty">' +
                  '<button class="cart-drawer__qty-btn" data-key="' + item.key + '" data-change="-1">-</button>' +
                  '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
                  '<button class="cart-drawer__qty-btn" data-key="' + item.key + '" data-change="1">+</button>' +
                  '</div>' +
                  '<button class="cart-drawer__item-remove" data-key="' + item.key + '">Remove</button>' +
                  '</div>' +
                  '</div>' +
                  '</div>';
                  });
                  cartDrawerItems.innerHTML = rows.join('');
                  if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = formatMoney(cart.total_price);
                  }
                 
                
                  function fetchCart() {
                  return fetch('/cart.js').then(function(res) { return res.json(); });
                  }
                  
                  function refreshCartDrawer() {
                  return fetchCart().then(function(cart) {
                  renderCartDrawer(cart);
                  return cart;
                  });
                  }
                  
                  function openCartDrawer() {
                  if (!cartDrawer) return;
                  refreshCartDrawer();
                  cartDrawer.classList.add('open');
                  if (cartDrawerOverlay) cartDrawerOverlay.classList.add('open');
                  cartDrawer.setAttribute('aria-hidden', 'false');
                  document.body.style.overflow = 'hidden';
                  }
                  
                  function closeCartDrawer() {
                  if (!cartDrawer) return;
                  cartDrawer.classList.remove('open');
                  if (cartDrawerOverlay) cartDrawerOverlay.classList.remove('open');
                  cartDrawer.setAttribute('aria-hidden', 'true');
                  document.body.style.overflow = '';
                  }
                  
                  if (headerCartToggle) {
                  headerCartToggle.addEventListener('click', function(e) {
                  e.preventDefault();
                  openCartDrawer();
                  });
                  }
                  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
                  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);
                  document.addEventListener('keydown', function(e) {
                  if (e.key === 'Escape') closeCartDrawer();
                  });
                  
                  if (cartDrawerItems) {
                  cartDrawerItems.addEventListener('click', function(e) {
                  var qtyBtn = e.target.closest('.cart-drawer__qty-btn');
                  var removeBtn = e.target.closest('.cart-drawer__item-remove');
                  var key, newQty, valueEl, currentQty;
                  if (qtyBtn) {
                  key = qtyBtn.dataset.key;
                  valueEl = qtyBtn.parentElement.querySelector('.cart-drawer__qty-value');
                  currentQty = parseInt(valueEl ? valueEl.textContent : 1);
                  newQty = Math.max(0, currentQty + parseInt(qtyBtn.dataset.change));
                  } else if (removeBtn) {
                  key = removeBtn.dataset.key;
                  newQty = 0;
                  } else {
                  return;
                  }
                  fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: key, quantity: newQty })
                  })
                  .then(function(res) { return res.json(); })
                  .then(function(cart) { renderCartDrawer(cart); });
                  });
                  }
                  
                    fetchCart().then(function(cart) { updateCartCount(cart.item_count); }).catch(function() {});

  // ---- CART QTY BUTTONS ----
  document.querySelectorAll('.qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const key = btn.dataset.key;
      const change = parseInt(btn.dataset.change);
      const valueEl = btn.parentElement.querySelector('.qty-value');
      const currentQty = parseInt(valueEl ? valueEl.textContent : 1);
      const newQty = Math.max(0, currentQty + change);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
      .then(function() { window.location.reload(); })
      .catch(function() { window.location.reload(); });
    });
  });

  // ---- BALL TYPE CARDS ----
  const ballTypeCards = document.querySelectorAll('.ball-type-card');
  ballTypeCards.forEach(function(card) {
    card.addEventListener('click', function() {
      ballTypeCards.forEach(function(c) {
        c.classList.remove('active');
        const specs = c.querySelector('.ball-type-card__specs');
        if (specs) specs.hidden = true;
      });
      card.classList.add('active');
      const specs = card.querySelector('.ball-type-card__specs');
      if (specs) specs.hidden = false;
    });
  });

  // ---- SCROLL REVEAL (lightweight) ----
  if ('IntersectionObserver' in window) {
    const revealEls = document.querySelectorAll(
      '.step, .product-card, .fire-class-item, .advantage-feature, .spec-box, .easy-feature, .stat-block'
    );
    const revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      revealObserver.observe(el);
    });

    // When revealed
    document.addEventListener('animationend', function() {}, false);
    const style = document.createElement('style');
    style.textContent = '.revealed { opacity: 1 !important; transform: translateY(0) !important; }';
    document.head.appendChild(style);
  }

})();
